import { useTranslation } from "react-i18next";
import Modal from "../../../components/Modal";
import { useState } from "react";
import { Input } from "@chakra-ui/react";
import { toast } from "react-toastify";
import { getAxiosInstance } from "../../../utils/axiosInstance";

interface NewRoleModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const NewRoleModal = (props: NewRoleModalProps) => {
  const [roleName, setRoleName] = useState<string>("");
  const { t } = useTranslation("translations");

  const saveNewRole = async () => {
    try {
      await getAxiosInstance().post('/Role', { roleName });
      setRoleName('');
      toast.success(t("ROLE_CREATED_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT});
      props.onClose();
    } catch (e) {
      toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT});
    }
  }
  
  return (
    <Modal
      header={t("NEW_ROLE_MODAL")} 
      isOpen={props.isOpen}
      onClose={props.onClose} 
      secondaryActionName={t("Save")}
      secondaryActionEnabled={roleName.length > 3}
      secondaryAction={() => saveNewRole()}
    >
      <Input
        value={roleName}
        onChange={(e) => setRoleName(e.target.value)}
        placeholder={t("NEW_ROLE_MODAL_INPUT_PLACE_HOLDER_TEXT")}
      />
    </Modal>
  );
}

export default NewRoleModal;